import { gql } from '@apollo/client/core';

const userReferrerQuery = gql`
  query userReferrer($invite: String!) {
    userReferrer(invite: $invite) {
      firstname
      lastname
      avatarUrl
    }
  }
`;

export default userReferrerQuery;
